module.exports = __webpack_public_path__ + "static/th-f88c782ea8ecda7c76f10a5e498ca843.svg";